const DEFAULT_TTL_MS = 30 * 60 * 1000;
const CACHE_PREFIX = 'nlims_cache_service:';

function getStorage() {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return null;
    return window.localStorage;
  } catch {
    return null;
  }
}

function buildKey(key) {
  return `${CACHE_PREFIX}${String(key ?? '').trim()}`;
}

function readEntry(key) {
  const storage = getStorage();
  if (!storage) return null;

  try {
    const raw = storage.getItem(buildKey(key));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

function writeEntry(key, entry) {
  const storage = getStorage();
  if (!storage) return;

  try {
    storage.setItem(buildKey(key), JSON.stringify(entry));
  } catch {
    // Best-effort cache only.
  }
}

export function setCachedValue(key, value, ttlMs = DEFAULT_TTL_MS) {
  const now = Date.now();
  const ttl = Number.isFinite(Number(ttlMs)) ? Math.max(0, Number(ttlMs)) : DEFAULT_TTL_MS;
  writeEntry(key, {
    value,
    savedAt: new Date(now).toISOString(),
    expiresAt: ttl > 0 ? now + ttl : null,
  });
  return value;
}

export function getCachedValue(key) {
  const entry = readEntry(key);
  if (!entry) return null;

  if (entry.expiresAt && Date.now() > Number(entry.expiresAt)) {
    removeCachedValue(key);
    return null;
  }

  return entry;
}

export function removeCachedValue(key) {
  const storage = getStorage();
  if (!storage) return;

  try {
    storage.removeItem(buildKey(key));
  } catch {
    // Ignore storage cleanup errors.
  }
}

export function clearCacheService() {
  const storage = getStorage();
  if (!storage) return;

  try {
    const keys = [];
    for (let index = 0; index < storage.length; index += 1) {
      const key = storage.key(index);
      if (key && key.startsWith(CACHE_PREFIX)) {
        keys.push(key);
      }
    }
    keys.forEach((key) => storage.removeItem(key));
  } catch {
    // Ignore storage cleanup errors.
  }
}

